import Head from 'next/head';
import {useRouter} from 'next/router';
import React from 'react';

import {HeadSEO} from '@udemy/head-seo';
import {ExperimentationProvider} from '@udemy/react-experimentation-provider';
import {SubscriptionPlanProductType, SubscriptionPlansProvider} from '@udemy/subscription-graphql';

import {getLayout} from 'src/components/layout';
import {SubscriptionCTAExperimentProvider} from 'src/contexts/subscription-cta-experiment-context';
import {CategoryPageProps} from 'src/features/category/types';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';

import {
    categoryPageExperimentationFeatures,
    CategoryWrapper,
} from './category-wrapper.react-component';

export const CategoryPage: React.FC<CategoryPageProps> = ({
    pageObject,
    staticCategory,
    locale,
    metaProps,
    staticDiscoveryUnits,
}) => {
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl(['p'], META_DEFAULT_BASE_URL);

    const robotRules =
        metaProps?.seoRobotRules && metaProps.seoRobotRules.length > 0
            ? metaProps.seoRobotRules
            : undefined;

    return (
        <>
            <HeadSEO
                title={metaProps?.seoTitle}
                ogTitle={metaProps?.seoTitle}
                description={metaProps?.seoDescription}
                ogDescription={metaProps?.seoDescription}
                ogType="video_lecture"
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
                robots={robotRules}
            />
            <ExperimentationProvider features={categoryPageExperimentationFeatures}>
                <SubscriptionCTAExperimentProvider
                    context={{
                        showCancelAnytime: true,
                    }}
                >
                    <SubscriptionPlansProvider
                        subscriptionPlanQueryVariables={[
                            {
                                filters: {
                                    productType: SubscriptionPlanProductType.Consumersubscription,
                                },
                                marketingURL: `${new URL(canonicalUrl).origin}${router.asPath}`,
                            },
                        ]}
                    >
                        <CategoryWrapper
                            pageObject={pageObject}
                            staticCategory={staticCategory}
                            staticDiscoveryUnits={staticDiscoveryUnits}
                        />
                    </SubscriptionPlansProvider>
                </SubscriptionCTAExperimentProvider>
            </ExperimentationProvider>
        </>
    );
};

// eslint-disable-next-line
(CategoryPage as any).getLayout = getLayout;
